"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientPlugins = void 0;
var initialize_1 = require("./initialize");
/**
 * Fetch all client plugins.
 * Depends on HooksBootstrapPlugin. See {@link HooksBootstrapPlugin}
 */
var getClientPlugins = function () {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var plugins = require(process.env.BERNIE_CLIENT_CONFIG_MODULE);
    return (0, initialize_1.initializePlugins)(plugins);
  } catch (e) {
    return [];
  }
};
exports.getClientPlugins = getClientPlugins;